module.exports = __webpack_public_path__ + "static/buzon-73cc16f459d39fff643cbfa1a846d9c0.png";